import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Mail } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0B2A45] text-stone-200" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Logo size={40} />
            <span className="font-serif text-xl font-semibold text-white">Guatemalan Spirits &amp; Fruit Juice</span>
          </div>
          <p className="text-sm text-stone-400 max-w-md leading-relaxed">
            Piccola azienda artigianale di Salerno, a cavallo tra la Costiera Amalfitana e il Cilento.
            Cocktail in fusto Cornelius 19L con vuoto a rendere, liquori d'autore e preparati per granita.
            Lavoro certosino, rispetto dell'ambiente, materie prime del territorio.
          </p>
          <p className="text-xs text-stone-500 max-w-md mt-4 leading-relaxed" data-testid="footer-company-info">
            Prodotto e confezionato da <b className="text-stone-300">BOTTY srl</b> — via Posidonia 26, 84100 Salerno.<br />
            Stabilimento di produzione: via Irno 42/44, Pontecagnano Faiano (SA).
          </p>
        </div>
        <div>
          <h4 className="eyebrow text-[#EAB308] mb-4">Naviga</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/#prodotti" className="hover:text-[#EAB308] transition-colors">Prodotti</a></li>
            <li><Link to="/negozio" className="hover:text-[#EAB308] transition-colors" data-testid="footer-shop-link">Shop</Link></li>
            <li><Link to="/listino" className="hover:text-[#EAB308] transition-colors" data-testid="footer-listino-link">Listino operatori</Link></li>
            <li><Link to="/comodato" className="hover:text-[#EAB308] transition-colors" data-testid="footer-comodato-link">Comodato impianti</Link></li>
            <li><Link to="/ingredienti" className="hover:text-[#EAB308] transition-colors" data-testid="footer-ingredienti-link">Ingredienti prodotti</Link></li>
            <li><Link to="/guida" className="hover:text-[#EAB308] transition-colors" data-testid="footer-guida-link">Guida</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-[#EAB308] transition-colors" data-testid="footer-chi-siamo-link">Chi siamo</Link></li>
            <li><Link to="/contatti" className="hover:text-[#EAB308] transition-colors" data-testid="footer-contatti-link">Contatti</Link></li>
            <li><Link to="/accedi" className="hover:text-[#EAB308] transition-colors">Area clienti</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow text-[#EAB308] mb-4">Contatti</h4>
          <ul className="space-y-3 text-sm text-stone-400">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#EAB308]" /> Salerno, Campania</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#EAB308]" /> botty78@hotmail.com</li>
            <li><Link to="/contatti" className="hover:text-[#EAB308] transition-colors" data-testid="footer-contact-form-link">Scrivici dal modulo contatti</Link></li>
            <li className="flex items-center gap-3 pt-2">
              <Instagram className="w-5 h-5 hover:text-[#EAB308] cursor-pointer transition-colors" />
              <Facebook className="w-5 h-5 hover:text-[#EAB308] cursor-pointer transition-colors" />
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} Guatemalan Spirits &amp; Fruit Juice (Guatemalan Spirit · Guate Spirit) · BOTTY srl — Salerno.
      </div>
    </footer>
  );
}
